// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/cropperjs/dist/cropper.css
// module id = 1115
// module chunks = 0